import "../styles/AdminInterface.css"
/* import "../styles/App.css"
 */import React, { useState, useEffect } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { Checkbox,ListItemText,TextField, FormControl, InputLabel, Button,Tooltip , Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'
import { formLabelClasses } from "@mui/material";


const AdminClassements = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.username !== undefined && !user.username.toUpperCase().includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)

  const [popupText, setPopupText] = useState(null)

  const [users, setUsers] = useState(null)
  const [localUsers, setLocalUsers] = useState(users);
  const [popupUser, setPopupUser] = useState(null)
  const [newUser, setNewUser] = useState(null)
  const [userList,setUserList] = useState([])
  const [localUserList, setLocalUserList] = useState([])

  const [jeu, setJeu] = useState([]);
  const [pseudo, setPseudo] = useState([]);
  const [campus, setCampus] = useState([]);
  const [groupe, setGroupe] = useState([]);

  // Données exemple pour les options des filtres
  const [jeuxOptions,setJeuxOptions] = useState([])
  const [pseudosOptions,setPseudosOptions] = useState([])
  const [campusOptions,setCampusOptions] = useState([])
  const [groupesOptions,setGroupesOptions] = useState([])

  const handleFilterChange = (setter) => (event) => {
    setter(event.target.value);
  };

  useEffect(() => {
    const getClassement = async () => {
      try {
        const response = await BackendAPI.getClassements()

        // Handle the response
        if (response.connectionApprouvee) {
          console.log("Connexion approuvée");
          console.log(response.classement)
          setUserList(response.classement);
        } else {
          console.error("Connection not approved:", response);
        }

      } catch (error) {
        console.error("Error fetching classement:", error);
      }
    };

    getClassement();
  }, []);


  const [hoveredRow, setHoveredRow] = useState(null);

  const handleMouseEnter = (u) => {
    setHoveredRow(u);
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };

  const mappingjeux={
    1:"1 - Cupcakes Battle",
    2:"2 - Find the Balance",
    3:"3 - What a bun!",
    4:"4 - Crazy Coo-Quiz Accounting",
    5:"5 - Crazy Coo-Quiz Financial Analysis"
  }

  const getUniqueValues = (data, attribute) => {
    /* console.log(values) */
    const values = data.map(item => {
      if (attribute === "numJeu") {
        return mappingjeux[item[attribute] - 10]; // Si l'attribut est 'numJeu', soustraire 10
      }
      return item[attribute]; // Sinon, retourner la valeur normale de l'attribut
    });
  
    const uniqueValues = [...new Set(values)].sort(); 
    /* uniqueValues.unshift("Tous");  */
/*     console.log(uniqueValues) */
    return uniqueValues;
  };

  useEffect(() => {
    if (userList !== null && userList.length>0) {
      setJeuxOptions(getUniqueValues(userList,"numJeu"))
      setPseudosOptions(getUniqueValues(userList,"pseudo"))
       setCampusOptions(getUniqueValues(userList,"campus"))
      setGroupesOptions(getUniqueValues(userList,"groupe")) 
      filterAndGroupList(userList)
    }
  }, [userList])


  const filterAndGroupList=(userList)=>{
    const groupedByUser = userList
       .filter((user) => (jeu.length>0 ? jeu.map(val=> parseInt(val.split(" - ")[0])).includes(user.numJeu-10) : true))
     .filter((user) => (pseudo.length>0 ? pseudo.includes(user.pseudo): true))
     .filter((user) => (campus.length>0 ? campus.includes(user.campus): true))
     .filter((user) => (groupe.length>0 ? groupe.includes(user.groupe): true))

      /* .filter((user) => (campus && campus!="Tous" ? user.campus==campus: true))
      .filter((user) => (groupe && groupe!="Tous" ? user.groupe==groupe: true)) */
      /*.filter((user) => (etudiant ? user.etudiant.includes(etudiant) : true))
      .filter((user) => (pseudo ? user.pseudo.includes(pseudo) : true))
      .filter((user) => (campus ? user.campus.includes(campus) : true))
      .filter((user) => (groupe ? user.groupe.includes(groupe) : true)) */
      .reduce((acc, curr) => {
      const { idUser, bestScore } = curr;
  
      // Vérifier si l'utilisateur existe déjà dans l'accumulateur
      if (!acc[idUser]) {
          acc[idUser] = { ...curr, totalBestScore: bestScore };
      } else {
          acc[idUser].totalBestScore += bestScore;
      }
  
      return acc;
    }, {});
  
    // Convertir l'objet en tableau
    setLocalUserList( Object.values(groupedByUser));
    return Object.values(groupedByUser)
  }

 useEffect(()=>{
  if (userList !== null && userList.length>0) {
    const localUserList=filterAndGroupList(userList)
    setLocalUserList( Object.values(localUserList));
  }
   
  },[jeu,pseudo,campus,groupe])



  const extractScores = (u) => {
    const data = userList.filter((val) => val.idUser === u.idUser); // Corrigez l'opérateur d'affectation `=` par `===`
    const gameScores = {};
  
    // Parcours de chaque entrée dans les données
    data.forEach(entry => {
      // Vérifie si le score est valide et supérieur à 0
      if (entry.bestScore > 0) {
        // Enregistre le score associé au numéro de jeu
        gameScores[`Jeu ${entry.numJeu-10}`] = entry.bestScore;
      }
    });
  
    // Transforme les résultats en tableau formaté avec des balises HTML pour les sauts de ligne
    return Object.entries(gameScores)
    .sort(([gameA], [gameB]) => {
      // Extrait le numéro du jeu pour effectuer un tri numérique
      const numA = parseInt(gameA.replace('Jeu ', ''), 10);
      const numB = parseInt(gameB.replace('Jeu ', ''), 10);
      return numA - numB;
    })
    .map(([game, score]) => `${game} : ${score} pts`)
    .join('<br>'); // Utilisation de <br> pour le rendu HTML
  };
  
/*   const renderHoverToolTips=(u)=>{
    console.log(userList)
    return(
      `Détail scores info: ${u.totalBestScore}`
    )
  }
 */

/*   console.log(localUserList) */

  const renderClassements = () => {
    if (userList !== null && userList.length>0) {
      return (
        <TableContainer component={Paper} style={{ maxHeight: "100%" }} >
          <Table stickyHeader aria-label="customized table">
            <TableHead>
              <TableRow key={"HEAD"}>
                {/* <TableCell align="center">Id</TableCell> */}

                <TableCell align="center" style={{ width: 150 }}>Nom</TableCell>
                <TableCell align="center" style={{ width: 150 }}>Prénom</TableCell>

                <TableCell align="center" style={{ width: 150 }}>Pseudo</TableCell>
                <TableCell align="center" style={{ width: 150 }}>Campus</TableCell>
                <TableCell align="center" style={{ width: 150 }}>Groupe</TableCell>
                <TableCell align="center" style={{ width: 150 }}>Score</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localUserList
                .sort((val1,val2)=>val2.totalBestScore-val1.totalBestScore)
                .map((u) => (
                  <TableRow key={u.idUser} style={{ height: 10 }}>
                    {/* <TableCell align="center">{u.id}</TableCell> */}
                    <TableCell align="center" style={{ width: 150 }}><TextField
                        value={u.nom}
                        disabled={true}
                        variant="outlined"
                        size="small"
                        
                      /></TableCell>
                    <TableCell align="center" style={{ width: 150 }}> <TextField
                        value={u.prenom}
                        disabled={true}
                        variant="outlined"
                        size="small"
                      /></TableCell>
                   {/*  <TableCell align="center" style={{ width: 300 }}><TextField
                        value={u.email}
                        disabled={true}
                        variant="outlined"
                        size="small"
                      /></TableCell> */}
                    <TableCell align="center" style={{ width: 150 }}> <TextField
                        value={u.pseudo}
                        disabled={true}
                        variant="outlined"
                        size="small"
                      /></TableCell>
                    <TableCell align="center" style={{ width: 150 }}>
                      <TextField
                        value={u.campus}
                        disabled={true}
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>

                    <TableCell align="center"style={{ width: 150 }}>
                      <TextField
                          value={u.groupe}
                          disabled={true}
                          variant="outlined"
                          size="small"
                        />                
                    </TableCell>
                    <TableCell align="center" style={{ width: 150 }}>
                    <Tooltip
                          title={
                            hoveredRow && hoveredRow.idUser === u.idUser ? (
                              <span dangerouslySetInnerHTML={{ __html: extractScores(u) }} />
                            ) : ''
                          }
                        placement="right"
                        arrow
                      >
                        <TextField
                          value={u.totalBestScore}
                          disabled={true}
                          variant="outlined"
                          size="small"
                          onMouseEnter={() => handleMouseEnter(u)}
                          onMouseLeave={handleMouseLeave}
                        />
                      </Tooltip>
                    </TableCell>
                
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>)
    }

    return null

  }



/* console.log(jeu) */

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div
        className="body-admin"
      >
        <Typography variant="h1" color="primary">Classements</Typography>
        <Divider />
        {/* {
        popupText!=null ?
        <Popup open={true} text={popupText} reponse={"Supprimer Utilisateur"} handleClose={handleClosePopup} ></Popup>
        :
        null
      } */}
        <div style={{ margin: 10 }}  >
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            {/* Liste déroulante pour le Jeu */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Jeux</InputLabel>
              <Select
                multiple
                value={jeu}
                onChange={(event) => setJeu(event.target.value)}
                label="Jeux"
                renderValue={(selected) => selected.join(', ')}
              >
                {jeuxOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    <Checkbox checked={jeu.indexOf(option) > -1} />
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
              
            {/*   <Select
                multiple
                value={jeu}
                onChange={handleFilterChange(setJeu)}
                label="Jeu"
              >
                                {jeuxOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                  <Checkbox checked={jeu.indexOf(option) > -1} />
                  <ListItemText primary={option} />
                </MenuItem>
                ))}
              </Select> */}
            </FormControl>

            {/* Liste déroulante pour l'Étudiant */}
           {/*  <FormControl size="small" variant="outlined">
              <InputLabel>Étudiant</InputLabel>
              <Select
                value={etudiant}
                onChange={handleFilterChange(setEtudiant)}
                label="Étudiant"
              >
                <MenuItem value=""><em>None</em></MenuItem>
                {etudiantsOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl> */}

            {/* Liste déroulante pour le Pseudo */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Pseudos</InputLabel>

             

              <Select
                multiple
                value={pseudo}
                onChange={(event) => setPseudo(event.target.value)}
                label="Pseudos"
                renderValue={(selected) => selected.join(', ')}

              >

                {pseudosOptions.map((option) => (
                   <MenuItem key={option} value={option}>
                   <Checkbox checked={pseudo.indexOf(option) > -1} />
                   <ListItemText primary={option} />
                 </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Campus */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Campus</InputLabel>

              <Select
                multiple
                value={campus}
                onChange={(event) => setCampus(event.target.value)}
                label="Campus"
                renderValue={(selected) => selected.join(', ')}

              >

                {campusOptions.map((option) => (
                   <MenuItem key={option} value={option}>
                   <Checkbox checked={campus.indexOf(option) > -1} />
                   <ListItemText primary={option} />
                 </MenuItem>
                ))}
              </Select>

            </FormControl>

            {/* Liste déroulante pour le Groupe */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Groupes</InputLabel>
              <Select
                multiple
                value={groupe}
                onChange={(event) => setGroupe(event.target.value)}
                label="Groupes"
                renderValue={(selected) => selected.join(', ')}

              >

                {groupesOptions.map((option) => (
                   <MenuItem key={option} value={option}>
                   <Checkbox checked={groupe.indexOf(option) > -1} />
                   <ListItemText primary={option} />
                 </MenuItem>
                ))}
              </Select>

             
            </FormControl>
          </div>
          <br></br>
          {renderClassements()}

          {/*   <br></br>
          <Typography variant="h5" color="primary">Créer un nouvel étudiant</Typography>

          {renderNewUser()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>



        {/* </div> */}

      </div></div>
  );
}

export default AdminClassements;

